<span>{{value.caption}}</span>
<span
  *ngIf="value.description"
  class="tip description"
>{{value.description}}</span>


